import React from 'react'
import Navbar from '../Components/Navbar'
import Product from '../Components/Product'

function Packages() {
  return (
  <>
  <Navbar />
  <Product />
  </>
  )
}

export default Packages